<template>
  <div class="ag-mapa">
    <div class="ag-mapa__scroll">
      <div class="ag-mapa__lienzo" :style="{ '--cols': semanas.length }">
        <div class="ag-mapa__meses">
          <span v-for="m in etiquetasMes" :key="m.mes" :style="{ gridColumn: m.col + 1 }">{{ m.nombre }}</span>
        </div>
        <div class="ag-mapa__cuerpo">
          <div class="ag-mapa__dias">
            <span>L</span><span></span><span>X</span><span></span><span>V</span><span></span><span>D</span>
          </div>
          <div class="ag-mapa__grid">
            <template v-for="(sem, si) in semanas" :key="si">
              <span
                v-for="(c, di) in sem"
                :key="`${si}-${di}`"
                class="ag-mapa__celda"
                :class="c ? `n${c.nivel}` : 'vacia'"
                :style="{ gridColumn: si + 1, gridRow: di + 1 }"
                :title="c ? `${fechaLarga(c.iso)}: ${euros(c.total)}` : ''"
              ></span>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="ag-mapa__pie">
      <span class="text-muted small">{{ diasConGasto }} días con gasto · {{ diasSinGasto }} días a cero</span>
      <span class="ag-mapa__escala">
        <span>Menos</span>
        <i v-for="(color, i) in ESCALA_CALOR" :key="i" :style="{ background: color }"></i>
        <span>Más</span>
      </span>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { diaSemanaLunes, nivelCalor, euros, ESCALA_CALOR, MESES_CORTOS, aISO, parseISO } from '../../utils/analisisGastos';

export default {
  name: 'AgMapaAno',
  props: {
    ano: { type: [String, Number], required: true },
    totalesDia: { type: Object, default: () => ({}) }
  },
  setup(props) {
    const hoyISO = aISO(new Date());

    const dias = computed(() => {
      const y = Number(props.ano);
      const out = [];
      for (let d = new Date(y, 0, 1); d.getFullYear() === y; d.setDate(d.getDate() + 1)) {
        const iso = aISO(d);
        if (iso > hoyISO) break;
        out.push({ iso, total: props.totalesDia[iso] || 0 });
      }
      const max = Math.max(...out.map((x) => x.total), 0);
      return out.map((x) => ({ ...x, nivel: nivelCalor(x.total, max) }));
    });

    const semanas = computed(() => {
      const cols = [];
      let col = new Array(7).fill(null);
      dias.value.forEach((d, i) => {
        const dow = diaSemanaLunes(d.iso);
        if (dow === 0 && i > 0) {
          cols.push(col);
          col = new Array(7).fill(null);
        }
        col[dow] = d;
      });
      if (col.some(Boolean)) cols.push(col);
      return cols;
    });

    const etiquetasMes = computed(() => {
      const out = [];
      semanas.value.forEach((sem, i) => {
        const c1 = sem.find((c) => c && c.iso.slice(8, 10) === '01');
        if (c1) out.push({ mes: c1.iso.slice(0, 7), col: i, nombre: MESES_CORTOS[parseInt(c1.iso.slice(5, 7), 10) - 1] });
      });
      return out;
    });

    const diasConGasto = computed(() => dias.value.filter((d) => d.total > 0).length);
    const diasSinGasto = computed(() => dias.value.length - diasConGasto.value);
    const fechaLarga = (iso) => parseISO(iso).toLocaleDateString('es-ES', { weekday: 'short', day: 'numeric', month: 'short' });

    return { semanas, etiquetasMes, diasConGasto, diasSinGasto, euros, fechaLarga, ESCALA_CALOR };
  }
};
</script>

<style scoped>
.ag-mapa__scroll { overflow-x: auto; padding-bottom: 4px; }
.ag-mapa__lienzo { min-width: calc(var(--cols) * 15px + 1.5rem); }
.ag-mapa__meses {
  display: grid;
  grid-template-columns: repeat(var(--cols), minmax(11px, 1fr));
  gap: 3px;
  margin-left: 1.3rem;
  font-size: 0.68rem;
  color: var(--tinta-suave);
  margin-bottom: 3px;
}
.ag-mapa__meses span { white-space: nowrap; }
.ag-mapa__cuerpo { display: flex; gap: 4px; }
.ag-mapa__dias { display: grid; grid-template-rows: repeat(7, 1fr); gap: 3px; font-size: 0.6rem; color: var(--tinta-suave); width: 1rem; }
.ag-mapa__dias span { line-height: 1; display: flex; align-items: center; }
.ag-mapa__grid {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(var(--cols), minmax(11px, 1fr));
  grid-template-rows: repeat(7, auto);
  gap: 3px;
}
.ag-mapa__celda { aspect-ratio: 1; border-radius: 3px; background: #eef1ec; }
.ag-mapa__celda.vacia { background: transparent; }
.ag-mapa__celda.n1 { background: #c9e3d2; }
.ag-mapa__celda.n2 { background: #8cc3a0; }
.ag-mapa__celda.n3 { background: #3f8f63; }
.ag-mapa__celda.n4 { background: #1a5a3a; }
.ag-mapa__celda:not(.vacia):hover { outline: 2px solid #eb6834; outline-offset: 1px; }
.ag-mapa__pie { display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 0.5rem; margin-top: 0.6rem; }
.ag-mapa__escala { display: inline-flex; align-items: center; gap: 3px; font-size: 0.7rem; color: var(--tinta-suave); }
.ag-mapa__escala i { width: 0.75rem; height: 0.75rem; border-radius: 2px; display: inline-block; }
.ag-mapa__escala span { margin: 0 0.25rem; }
</style>
